module.exports = __webpack_public_path__ + "static/media/home.25b512b9.svg";